import { useState, useEffect } from 'react';
import { fetchMuthootRegions } from 'features/disputes/MuthootDisputes/service';
import { isMuthoot } from 'Routes/Routes';

const useMuthootRegions = (enabled = true) => {
  const [regions, setRegions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if(!isMuthoot || !enabled ) return;

    fetchMuthootRegions()
      .then(data => setRegions(data))
      .catch(err => setError(err))
      .finally(() => setLoading(false));

  }, []);
  return { regions, loading, error };
};

export default useMuthootRegions;
